// removed by extract-text-webpack-plugin
module.exports = {"root":"_392Yq","image":"_1vV10","infoBlock":"_1UsEs","title":"_3wtNi","descr":"_38v_i","nameInfo":"_1bnSa","city":"_s3r_D","quotation":"_7Licz"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TestimonialBlock/components/Testimonial/Testimonial.scss
// module id = 1364
// module chunks = 3